import { Route, Redirect, withRouter, match } from "react-router";
import * as React from "react";
import * as models from "app/models/requireme";
import * as resources from "app/resources/index";
import * as history from "app/main/history";
import { BitacoraRADForm } from "./form";

type Entity = models.BitacoraRAD;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value: Promise<Entity> | Entity;
}

const resource = resources.BitacoraRAD;

class BitacoraRADEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue() };
    }
    get id(): number | "new" {
        const id = this.props.match.params.id;
        return id == "new" ? id : Number.parseInt(id);
    }
    async getValue(): Promise<Entity> {
        if (this.id == "new") {
            const now = new Date();
            return {
                FechaSolicitud: now,
                FechaProgramada: now,
                Paquetes: [],
                CanalEntrada: 0, 
                QuienSolicita: 0, 
                HistorialStatus:[],
                Observaciones:"",
                NombreQuienSolicita: ""
            };
        } else {
            return await resource.Get(this.id);
        }
    }

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onGuardar = async () => {
        const value = await this.state.value;
        const id = this.id;
        //NOTA: No se pueden modificar turno, solamente agregar nuevos
        const func = resource.Add;

        await resources.User.SessionRx.subscribe({
            next(x) {
                value.UsuarioCreador = x.Nombre;
                const ddd= value;
                debugger;
                func(value);
                history.go("../");
            }
          });
    }

    render() {
        const props = this.props;
        const params = props.match!.params.id;
        return <BitacoraRADForm
            value={this.state.value}
            onChange={this.onChange}
            nuevo={this.id == "new"}
            permisos={resources.User.PermisoRx}
            onGuardar={this.onGuardar} />;
    }
}

export const BitacoraRADEdit = withRouter(BitacoraRADEditComp);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/bitacoraRAD/edit/edit.tsx